export default __webpack_public_path__ + "static/videoN3-b4a84b890abaf862d509139ca4b995c3.jpg";